//
// Randomize entries
//

$.fn.randomizeEntries = function(entry) {
    var $this = $(this);
    var entryListItem = $this.find(entry);
    
    //Copy entries
    var entryListItemCopy = entryListItem.clone(true);
    
    // Remove original list
    entryListItem.remove();
    
    // Randomize and display entries
    while(entryListItemCopy.length > 0){
    
        // Choose random index of enty array
        var randomIndex = Math.floor(Math.random() * entryListItem.length);
    
        $this.append(entryListItemCopy.splice(randomIndex, 1));
    }
};